//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const isSnackbarFadeVisible = ref(false)
    const isSnackbarScaleVisible = ref(false)
    const isSnackbarScrollReveseVisible = ref(false)

    return { isSnackbarFadeVisible, isSnackbarScaleVisible, isSnackbarScrollReveseVisible }
  },
}
